import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { AuthFacadeService } from 'src/app/modules/auth/state/auth/auth.facade.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';
import { CryptoService } from 'src/app/services/crypto.service';
import { CookieService } from 'src/app/services/cookie.service';
import { PopupMessageComponent } from 'src/app/modules/navigation/popup-message/popup-message.component';
import { MatDialog } from '@angular/material/dialog';
import { Constants } from 'src/app/common/constants/constants';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-login-with-password',
  templateUrl: './login-with-password.component.html',
  styleUrls: ['./login-with-password.component.scss']
})
export class LoginWithPasswordComponent implements OnInit {
  form!: FormGroup;
  ref_code:any = null;
  storeData: any ;
  timeout:any=Constants.POPUP_TIMEOUT;
  emailValidation = new RegExp(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );

  constructor(private authFacadeService : AuthFacadeService, private router: Router,
              private notificationService : NotificationService, private cryptoService:CryptoService,
              private formBuilder: FormBuilder,public dialog: MatDialog,
              private route:ActivatedRoute, private utilsService : UtilsService,
              private cookieService : CookieService, private authService : AuthService) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((parmas : any)=>{
      console.log("GOT Refereal code",parmas['referral_code']);
      this.ref_code = parmas['referral_code'] || null;
    });
    localStorage.setItem('referral',String(this.ref_code));

    this.authFacadeService.getLoginResult$.subscribe((stores : any) => {
      this.storeData = stores;
      if(this.storeData && this.storeData.response.loginResponse){
        let encryptedToken : any = this.cryptoService.encrypt(this.storeData.response.loginResponse.token);
        this.cookieService.setCookie('token', encryptedToken);
        this.authService.fetchUser().subscribe((res : any) => {
            console.log('user',res)
            if(res && res.data && res.data.personal_details){
            const username = `${res.data.personal_details.first_name} ${res.data.personal_details.last_name}`;
            this.utilsService.onUserUpdate.next(username);
            localStorage.setItem('username', username);
            let encryptedUserId : any = this.cryptoService.encrypt(res.data.personal_details.user_id);
            localStorage.setItem('userId', encryptedUserId);
            //this.router.navigateByUrl('/dashboard');
              this.router.navigateByUrl('/dashboard/invest');
            }
          });

      }
      else if(this.storeData && this.storeData.response.errorMessage){
        const popup = this.dialog.open(PopupMessageComponent,{
          data:{
            title:"Error",
            message:this.storeData.response.errorMessage.error ?
                this.storeData.response.errorMessage.error.message : 'Error on login'
          }
        })
        popup.afterOpened().subscribe((res : any)=>{
          setTimeout(()=>{
            popup.close();
          }, this.timeout)
        })
        // this.notificationService.showError(this.storeData.response.errorMessage.error.message, "Error");
      }
    });

    this.form = this.formBuilder.group({
      mobileOrEmail: new FormControl('', [Validators.required, Validators.pattern(this.emailValidation), NoWhitespaceValidator()]),
      password: new FormControl('', [Validators.required])
    });
  }

  submit(){
    const data = {
      "email" : this.form.controls['mobileOrEmail'].value,
      "type" : 1,
      "password" : this.form.controls['password'].value,
      "referred_by" : this.ref_code,
      "utmDetails": {
          "utmSource": "",
          "utmMedium" :"",
          "utmCampaign": ""
      }
  }
    this.authFacadeService.login(data);
  }


  ngOnDestroy() : void{
    this.authFacadeService.clearState();
  }


}

export function NoWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): any => {
      window.setTimeout(() => {
          if (control.value && control.value != '') {
              let trimedvalue = control.value.replace(/\s/g, '');
              control.setValue(trimedvalue);
          }
      }, 10);
  };
}
